export default "__VITE_ASSET__imxvjhBf__"